import { SystemLogItem, SystemLogFilter } from './systemLogs.types';
import api from '../../utils/api';

export class SystemLogsController {
  /**
   * Busca a lista de logs de auditoria do servidor.
   */
  static async fetchLogs(filters: SystemLogFilter): Promise<SystemLogItem[]> {
    try {
      const params: Record<string, any> = {};
      if (filters.userId !== null && filters.userId > 0) {
        params.user_id = filters.userId;
      }
      if (filters.resource && filters.resource !== 'Todos') {
        params.resource = filters.resource;
      }
      if (filters.startDate) {
        params.start_date = filters.startDate;
      }
      if (filters.endDate) {
        params.end_date = filters.endDate;
      }

      const response = await api.get<{ success: boolean; data: any[] }>('/logs', { params });
      
      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        return response.data.data.map((item: any) => {
          // Devido ao interceptor do Axios que converte snake_case para camelCase recursivamente,
          // as chaves originais como 'user_id', 'user_name' etc. podem já ter sido transformadas em
          // 'userId', 'userName' etc. Suportamos ambas de forma totalmente resiliente.
          const userId = item.userId !== undefined ? item.userId : item.user_id;
          const userName = item.userName || item.user_name || 'Operador Desconhecido';
          const userSector = item.userSector || item.user_sector || 'Geral';
          const resourceId = item.resourceId !== undefined ? item.resourceId : item.resource_id;
          const createdAt = item.createdAt || item.created_at;

          return {
            id: item.id,
            userId: userId,
            userName: userName,
            userSector: userSector,
            action: item.action,
            resource: item.resource,
            resourceId: resourceId !== undefined ? resourceId : null,
            details: item.details,
            createdAt: createdAt
          };
        });
      }
      return [];
    } catch (err) {
      console.error('Erro ao buscar logs de auditoria:', err);
      throw err;
    }
  }
}
